<template>
    <el-dialog
        :model-value="props.visible"
        title="所得减免类型选项表"
        width="1000"
        top="6vh"
        destroy-on-close
        :close-on-click-modal="false"
        @open="onOpen"
        @closed="closedModal"
    >
        <div v-loading="pageLoading">
            <div class="my-tax-enter-sub-table-wrap">
                <table>
                    <tbody>
                    <tr class="title-row">
                        <td class="title01 center strong" width="60">序号</td>
                        <td class="title01 center strong" width="80">选择</td>
                        <td class="title01 center strong" width="100">代码</td>
                        <td class="title01 center strong" width="20%">减免项目类别</td>
                        <td class="title01 center strong">优惠事项</td>
                        <td class="title01 center strong" width="200">本年累计金额</td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[0].t_xh">1</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM11100'].checked"
                                :disabled="tableData['SDJM11100'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[0].yhswsx">SDJM11100
                        </td>
                        <td class="title01 ng-binding" rowspan="2" ng-bind="sdjmGrid.sdjmGridlb[0].t_jejslxMc">
                            农、林、牧、渔业项目
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[0].ewbhgjz">
                            从事农、林、牧、渔业项目的所得减免征收企业所得税（免税项目）
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM11100'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM11100'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[1].t_xh">2</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM11200'].checked"
                                :disabled="tableData['SDJM11200'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[1].yhswsx">SDJM11200
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[1].ewbhgjz">
                            从事农、林、牧、渔业项目的所得减免征收企业所得税（减半项目）
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM11200'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM11200'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[2].t_xh">3</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM21100'].checked"
                                :disabled="tableData['SDJM21100'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[2].yhswsx">SDJM21100
                        </td>
                        <td class="title01 ng-binding" rowspan="2" ng-bind="sdjmGrid.sdjmGridlb[2].t_jejslxMc">
                            国家重点扶持的公共基础设施项目
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[2].ewbhgjz">
                            从事国家重点扶持的公共基础设施项目（除农村饮水工程）投资经营的所得定期减免企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM21100'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM21100'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[3].t_xh">4</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM21200'].checked"
                                :disabled="tableData['SDJM21200'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[3].yhswsx">SDJM21200
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[3].ewbhgjz">
                            从事农村饮水工程新建项目投资经营的所得定期减免企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM21200'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM21200'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[4].t_xh">5</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM31000'].checked"
                                :disabled="tableData['SDJM31000'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[4].yhswsx">SDJM31000
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[4].t_jejslxMc">
                            从事符合条件的环境保护、节能节水项目的所得定期减免企业所得税
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[4].ewbhgjz"></td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM31000'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM31000'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[5].t_xh">6</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM40010'].checked"
                                :disabled="tableData['SDJM40010'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[5].yhswsx">SDJM40010
                        </td>
                        <td class="title01 ng-binding" rowspan="2" ng-bind="sdjmGrid.sdjmGridlb[5].t_jejslxMc">
                            符合条件的技术转让项目
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[5].ewbhgjz">
                            符合条件的一般技术转让项目所得减免征收企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM40010'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM40010'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[6].t_xh">7</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM40020'].checked"
                                :disabled="tableData['SDJM40020'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[6].yhswsx">SDJM40020
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[6].ewbhgjz">
                            符合条件的中关村国家自主创新示范区特定区域技术转让项目所得减免征收企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM40020'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM40020'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[7].t_xh">8</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM50000'].checked"
                                :disabled="tableData['SDJM50000'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[7].yhswsx">SDJM50000
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[7].t_jejslxMc">
                            实施清洁发展机制项目的所得定期减免企业所得税
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[7].ewbhgjz"></td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM50000'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM50000'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[8].t_xh">9</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM60000'].checked"
                                :disabled="tableData['SDJM60000'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[8].yhswsx">SDJM60000
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[8].t_jejslxMc">
                            符合条件的节能服务公司实施合同能源管理项目的所得定期减免企业所得税
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[8].ewbhgjz"></td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM60000'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM60000'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[10].t_xh">11</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM70001'].checked"
                                :disabled="tableData['SDJM70001'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[10].yhswsx">SDJM70001
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[10].ewbhgjz">
                            线宽小于65纳米（含）或投资额超过150亿元的集成电路生产项目
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[10].t_jejslxMc">
                            原有集成电路项目优惠政策（继续执行至到期）
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM70001'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM70001'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[11].t_xh">12</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM70002'].checked"
                                :disabled="tableData['SDJM70002'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[11].yhswsx">SDJM70002</td>
                        <td class="title01 ng-binding" rowspan="3" ng-bind="sdjmGrid.sdjmGridlb[11].t_jejslxMc">
                            集成电路项目新优惠政策
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[11].ewbhgjz">
                            国家鼓励的线宽小于28纳米（含）的集成电路生产项目
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM70002'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM70002'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[13].t_xh">13</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM70003'].checked"
                                :disabled="tableData['SDJM70003'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[13].yhswsx">SDJM70003</td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[13].ewbhgjz">
                            国家鼓励的线宽小于65纳米（含）的集成电路生产项目
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM70003'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM70003'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[14].t_xh">14</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM70004'].checked"
                                :disabled="tableData['SDJM70004'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[14].yhswsx">SDJM70004
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[14].ewbhgjz">
                            国家鼓励的线宽小于130纳米（含）的集成电路生产项目
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM70004'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM70004'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="sdjmGrid.sdjmGridlb[12].t_xh">15</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['SDJM99999'].checked"
                                :disabled="tableData['SDJM99999'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="sdjmGrid.sdjmGridlb[12].yhswsx">SDJM99999
                        </td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[12].t_jejslxMc">其他</td>
                        <td class="title01 ng-binding" ng-bind="sdjmGrid.sdjmGridlb[12].ewbhgjz"></td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['SDJM99999'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['SDJM99999'].checked = true"
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="my-footer">
                <el-button
                    type="primary"
                    @click="onConfirm">确定
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import {ElMessage, ElMessageBox} from "element-plus";
import {cloneDeep} from "lodash";
import Big from "big.js";

const props = defineProps({
    visible: {
        type: Boolean,
        required: true
    },
    currentData: {
        type: Object,
        default: () => {
        }
    }
})

const initialData = {
    'SDJM11100': {
        name: '从事农、林、牧、渔业项目的所得减免征收企业所得税（免税项目）',
        checked: false,
        value: 0.00,
    },
    'SDJM11200': {
        name: '从事农、林、牧、渔业项目的所得减免征收企业所得税（减半项目）',
        checked: false,
        value: 0.00,
    },
    'SDJM21100': {
        name: '从事国家重点扶持的公共基础设施项目（除农村饮水工程）投资经营的所得定期减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'SDJM21200': {
        name: '从事农村饮水工程新建项目投资经营的所得定期减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'SDJM31000': {
        name: '从事符合条件的环境保护、节能节水项目的所得定期减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'SDJM40010': {
        name: '符合条件的一般技术转让项目所得减免征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'SDJM40020': {
        name: '符合条件的中关村国家自主创新示范区特定区域技术转让项目所得减免征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'SDJM50000': {
        name: '实施清洁发展机制项目的所得定期减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'SDJM60000': {
        name: '符合条件的节能服务公司实施合同能源管理项目的所得定期减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'SDJM70001': {
        name: '线宽小于65纳米（含）或投资额超过150亿元的集成电路生产项目',
        checked: false,
        value: 0.00,
    },
    'SDJM70002': {
        name: '国家鼓励的线宽小于28纳米（含）的集成电路生产项目',
        checked: false,
        value: 0.00,
    },
    'SDJM70003': {
        name: '国家鼓励的线宽小于65纳米（含）的集成电路生产项目',
        checked: false,
        value: 0.00,
    },
    'SDJM70004': {
        name: '国家鼓励的线宽小于130纳米（含）的集成电路生产项目',
        checked: false,
        value: 0.00,
    },
    'SDJM99999': {
        name: '其他所得减免类未列明优惠',
        checked: false,
        value: 0.00,
    },
}

const pageLoading = ref(false)
const tableData = ref(cloneDeep(initialData))

function onOpen() {
    (props.currentData.subData || []).forEach(it => {
        tableData.value[it.key].value = it.value
        tableData.value[it.key].checked = it.checked
        if (it.disCode != null) {
            tableData.value[it.key].disCode = it.disCode
        }
    })
}

function onConfirm() {
    const resData = []
    let total = new Big(0) // 合计

    Object.keys(tableData.value).forEach(key => {
        if (tableData.value[key].checked) {
            resData.push({
                key,
                ...tableData.value[key],
            })
            total = total.plus(tableData.value[key].value)
        }
    })
    emit('update:visible', false)
    emit('onConfirm', resData, total.toNumber())
}

const emit = defineEmits(['update:visible', 'onConfirm'])

function closedModal() {
    emit('update:visible', false)
    tableData.value = cloneDeep(initialData)
}
</script>

<style scoped lang="scss">
.my-footer {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 30px;
}

.my-tax-enter-sub-table-wrap {
    max-height: calc(80vh - 100px);
    overflow-y: auto;
    padding-right: 10px;
    padding-bottom: 3px;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
    }

    &::-webkit-scrollbar-track-piece {
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(211, 211, 211, 0.9);
        border-radius: 10px;
    }

    > table {
        border: 1px solid #dcdcdc;
        border-collapse: collapse;

        tr {
            td {
                background-color: #fafafa;
                border: 1px solid #dcdcdc;
                padding: 10px 16px;

                &:nth-child(1) {
                    text-align: center;
                    width: 70px;
                }

                &:nth-child(2) {
                    width: 70px;
                    text-align: center;
                }

                &:nth-child(3) {
                    width: 120px;
                    text-align: center;
                }

                &:last-child {
                    width: 160px;
                    max-width: 160px;
                }
            }

            &.title-row {
                text-align: center;

                td {
                    font-weight: 700;
                }
            }
        }
    }
}

:deep(.left-number-input) {
    &.el-input-number .el-input__inner {
        text-align: left;
    }
}
</style>
